import { render } from "./BlocoAccordion.vue?vue&type=template&id=a557ffd6&scoped=true"
import script from "./BlocoAccordion.vue?vue&type=script&lang=js"
export * from "./BlocoAccordion.vue?vue&type=script&lang=js"

import "./BlocoAccordion.vue?vue&type=style&index=0&id=a557ffd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a557ffd6"]])

export default __exports__